import axios from "axios";
const url = process.env.REACT_APP_BACKEND_URL;

export async function registerOracle(
    authToken,
    bytes32EventId,
    eventId,
    oracleId,
    stakeValue,
    winnerVote) {
    return axios.post(url + "/oracles", {
       bytes32EventId,
        eventId,
        oracleId,
        stakeValue,
        winnerVote
    }, {
            headers: {
                Authorization: `Bearer ${authToken}`
            }
        })
        .then(function (response) {
            console.log(response);
        })
        .catch(function (error) {
            console.log(error);
        });

}



// WEBPACK FOOTER //
// ./src/api-calls/oracles.js